import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalRegistration";
import * as actions from "./actions";
import * as types from "./types";
import { persistCompanyPortalSession } from "../../../utils/companyRegistration";
import { showErrorMsg } from "../../../utils/Helpers";

const extractErrorMessage = (error) =>
  error?.response?.data?.message || error?.message || "";

function* getMyCompanySaga({ payload }) {
  try {
    const company = yield call(apis.fetchMyCompany);
    yield put(actions.getMyCompanySuccess(company));

    // Keep `auth.login.company` as the app-wide source of truth (NavBar,
    // CompanyHeader, CompanyInfoCard, etc. already read from there). The
    // dedicated slice still owns nested pieces like the active edit request
    // that don't belong on the auth session.
    if (company && typeof company === "object") {
      persistCompanyPortalSession({ company });
    }

    if (typeof payload?.onSuccess === "function") payload.onSuccess(company);
  } catch (error) {
    const message = extractErrorMessage(error);
    yield put(actions.getMyCompanyFailure({ error: message }));
    // Silent by default — the Profile page is fine falling back to the
    // already-persisted company data. Opt-in via `payload.loud` when the
    // caller wants the user to see the failure.
    if (payload?.loud && message) yield showErrorMsg(message);
  }
}

export default function* companyMyCompanySagas() {
  yield takeEvery(types.GET_MY_COMPANY_REQUEST, getMyCompanySaga);
}
